var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 0.833252C14.25 0.833252 18.3333 4.91658 18.3333 9.99992C18.3333 15.0833 14.25 19.1666 9.16667 19.1666C4.08333 19.1666 0 15.0833 0 9.99992C0 4.91658 4.08333 0.833252 9.16667 0.833252ZM9.16667 17.4999C13.3333 17.4999 16.6667 14.1666 16.6667 9.99992C16.6667 5.83325 13.3333 2.49992 9.16667 2.49992C5 2.49992 1.66667 5.83325 1.66667 9.99992C1.66667 14.1666 5 17.4999 9.16667 17.4999ZM8.33333 5.83325V10.8333C8.33333 11.3333 8.66667 11.6666 9.16667 11.6666C9.66667 11.6666 10 11.3333 10 10.8333V5.83325C10 5.33325 9.66667 4.99992 9.16667 4.99992C8.66667 4.99992 8.33333 5.33325 8.33333 5.83325ZM9.16667 15.1666C9.75 15.1666 10.1667 14.6666 10.1667 14.1666C10.1667 13.6666 9.66667 13.1666 9.16667 13.1666C8.66667 13.1666 8.16667 13.5833 8.16667 14.1666C8.16667 14.7499 8.58333 15.1666 9.16667 15.1666Z",
    fill: "#85929B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarn);
export default __webpack_public_path__ + "static/media/warn.1cbbb9804cb48b0aa49e41aa1e810a9e.svg";
export { ForwardRef as ReactComponent };